<template>
    <div class="drag-drop-container">
        <div class="bg-gray">
            <input
                type="file"
                multiple
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="dragdrop-input"
                @change="onChange"
                ref="file"
                :accept="acceptedFileTypes"
            />

            <label for="assetsFieldHandle" class="block cursor-pointer">
                <div v-if="!useIcon">
                    <span class="underline">Click here</span>
                    to upload {{ fileLabel }}
                </div>
                <div v-else class="icon-container">
                    <md-icon>attach_file</md-icon>
                    <br />
                    Upload {{ fileLabel }}
                </div>
            </label>
        </div>
        <div class="file-names">
            <ul class="filename-list" v-if="this.filelist.length" v-cloak>
                <li class="text-sm" v-for="(file, index) in filelist" :key="index">
                    {{ file.name }}
                    <button
                        class="file-remove-btn"
                        type="button"
                        @click="remove(filelist.indexOf(file))"
                        title="Remove file"
                        aria-label="Remove file"
                    >
                        <md-icon class="file-remove-icon">close</md-icon>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'DocumentFileUpload',
    mixins: [GeneralMixin],
    data() {
        return { filelist: [] };
    },
    props: {
        useIcon: { type: Boolean, default: false },
        documents: { type: Array, default: () => [] },
        acceptedFileTypes: { type: String, default: '.pdf,.xlsx,.xls,.txt,.ppt,.pptx,.docx,.doc,.mp4' },
        fileLabel: { type: String, default: 'files' }
    },
    mounted() {
        if (this.documents.length > 0) {
            this.filelist = this.documents;
        }
    },
    methods: {
        onChange(e) {
            const inputFiles = Array.from((e && e.target && e.target.files) || []); // avoid $refs access timing issue
            this.checkFileSize(inputFiles);
            this.$emit('upload-success', this.filelist);
        },
        remove(i) {
            this.filelist.splice(i, 1);
            if (this.$refs.file) {
                this.$refs.file.value = '';
            }
            this.$emit('upload-remove', i, this.filelist);
        },
        checkFileSize(files) {
            files.forEach((file) => {
                if (file.size / 1024 > 15000) {
                    this.$notify({ message: `${file.name} exceeded the maximum size.`, type: 'danger' });
                } else {
                    const name = this.handleDuplicateFileNames(file);
                    const blob = file.slice(0, file.size, file.type);
                    this.filelist.push(new File([blob], name, { type: file.type }));
                }
            });
        },
        handleDuplicateFileNames(item) {
            const documentNames = this.filelist.map((f) => f.name.toLowerCase());
            const parts = item.name.split('.');
            const fileExt = parts.pop();
            const fileName = parts.join('.');
            if (documentNames.includes(item.name.toLowerCase())) {
                let index = 1;
                let name = `${fileName} (${index}).${fileExt}`;
                while (documentNames.includes(name.toLowerCase())) {
                    index += 1;
                    name = `${fileName} (${index}).${fileExt}`;
                }
                return name;
            }
            return item.name;
        }
    }
};
</script>

<style lang="scss" scoped>
.drag-drop-container {
    margin-top: 10px;
    text-align: center;
    > .bg-gray {
        height: 100%;
        width: 100%;

        .underline {
            text-decoration: underline;
            cursor: pointer;
        }
        .dragdrop-input {
            width: 1px;
            height: 1px;
            position: absolute;
            overflow: hidden;
        }
    }

    .file-names {
        max-height: 190px;
        overflow: auto;
        .filename-list {
            list-style: none;
            text-align: left;
            padding-left: 5px;
        }

        /* Remove previous gray styling and center icon */
        .file-remove-btn {
            background: none !important;
            color: inherit;
            border: none;
            cursor: pointer;
            padding: 0 4px;
            display: inline-flex;
            align-items: center; /* vertical center */
            justify-content: center;
            line-height: 1; /* tighten */
            vertical-align: middle;
        }
    }

    label {
        > div {
            height: 100%;
        }
    }
}

.icon-container {
    width: 150px;
    padding: 38px 10px;
    border: 1px solid #eee;
    margin-left: 10px;
    font-weight: 500;
    color: #777;
}

.file-remove-icon {
    color: #ff5245 !important;
    font-size: 18px;
    display: inline-block;
}
.file-remove-btn:hover .file-remove-icon {
    color: #d40000 !important;
}
</style>
